import React from 'react';
import { Checkbox } from 'antd';
import { GetUsersRequest } from '@gen/proto/lr/transcript/v1alpha1/transcript_pb';
import { CheckboxValueType } from 'antd/es/checkbox/Group';

interface UserListFilterProps {
  setGroupFilter: (groupFilter: GetUsersRequest.GroupFilter[]) => void;
}

interface CheckboxOption {
  label: string;
  value: GetUsersRequest.GroupFilter;
}

function UserListGroupFilter(props: UserListFilterProps) {
  const groupOptions: CheckboxOption[] = [
    { label: 'Admin', value: GetUsersRequest.GroupFilter.ADMIN },
    { label: 'Realtime captioning', value: GetUsersRequest.GroupFilter.RTC },
  ];

  const onChange = (e: CheckboxValueType[]) => {
    if (e.length === 0) {
      props.setGroupFilter([GetUsersRequest.GroupFilter.GROUP_UNSPECIFIED]);
      return;
    }
    props.setGroupFilter([...(e as GetUsersRequest.GroupFilter[])]);
  };

  return (
    <>
      <Checkbox.Group options={groupOptions} onChange={onChange} />
    </>
  );
}

export default UserListGroupFilter;
